import { EntityKeywords } from './EntityKeywords';

/**
 * Ключі бренду — тонка обгортка над спільним компонентом.
 *
 * Вкладка «Ключі» однакова для бренда, гри й кластера: той самий перелік, ті самі фільтри,
 * ті самі двері на імпорт. Три копії розійшлися б на першій же правці — фільтр, доданий в
 * одну, не зʼявився б у двох інших, і ніхто б цього не помітив, бо кожна виглядає робочою.
 */
export function BrandKeywords({ brandId }: { brandId: string }): React.JSX.Element {
  return <EntityKeywords ownerType="brand" ownerId={brandId} />;
}
